import React, { useContext, useEffect, useMemo, useState } from "react";
import { LeaderboardContext } from "../../provider/leaderboard";
import { buildPaginationItems } from "../../utils/buildPaginationItems";

const Pagination = ({ weektype, Paginationdata }) => {
  const { getWeekResultAT, getWeekResultLW, getWeekResultTW } =
    useContext(LeaderboardContext);

  const currentPage = Paginationdata?.currentPage || 1;
  const totalPages = Paginationdata?.totalPages || 1;
  const [activePage, setActivePage] = useState(currentPage);

  useEffect(() => {
    setActivePage(currentPage);
  }, [currentPage]);

  const pageItems = useMemo(
    () => buildPaginationItems(activePage, totalPages),
    [activePage, totalPages],
  );

  const handleClick = (pageNumber) => {
    if (pageNumber === activePage) return;

    if (weektype === "Previous") {
      getWeekResultLW(pageNumber);
    } else if (weektype === "current") {
      getWeekResultTW(pageNumber);
    } else if (weektype === "alltime") {
      getWeekResultAT(pageNumber);
    } else {
      return;
    }

    setActivePage(pageNumber);
  };

  if (totalPages <= 1) return null;

  return (
    <nav
      className="leaderboard-pagination"
      aria-label="Leaderboard pages"
    >
      <div className="pagination-element-wrapper">
        {pageItems.map((item) =>
          item.type === "ellipsis" ? (
            <span
              key={item.key}
              className="pagination-ellipsis"
              aria-hidden="true"
            >
              ....
            </span>
          ) : (
            <button
              key={item.key}
              type="button"
              className={`pagination-element ${
                activePage === item.page ? "active" : ""
              }`}
              onClick={() => handleClick(item.page)}
              aria-label={`Page ${item.page}`}
              aria-current={activePage === item.page ? "page" : undefined}
            >
              {item.page}
            </button>
          ),
        )}
      </div>
    </nav>
  );
};

export default Pagination;
